import {releaseNotesDe} from './releaseNotes/releaseNotesDe'
import {releaseNotesEn} from './releaseNotes/releaseNotesEn'

export const release_notes_de: ReleaseNotes = releaseNotesDe
export const release_notes_en: ReleaseNotes = releaseNotesEn

